import { render, staticRenderFns } from "./vieworEditDeclaration.vue?vue&type=template&id=25f37604&scoped=true"
import script from "./vieworEditDeclaration.vue?vue&type=script&lang=js"
export * from "./vieworEditDeclaration.vue?vue&type=script&lang=js"
import style0 from "./vieworEditDeclaration.vue?vue&type=style&index=0&id=25f37604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f37604",
  null
  
)

export default component.exports